import React, { Component } from 'react';
import ModalOverlay from "../../../../../components/UI/ModalOverlay";
import theme from '../../../../../Theme/theme';
import axios from "axios";
import { API_URL } from "config/constants";
import AddForm from './AddForm';

const ADD_TRAINER_TITLE = "Add Trainers";

export default class AddTrainers extends Component {
    render() {
        return (
            <ModalOverlay
                modalStyle={style.modalStyle}
                header={ADD_TRAINER_TITLE}
                headerStyle={style.headerStyle}
                headerBodyStyle={style.headerBodyStyle}
                bodyStyle={style.modalBody}
                underLayerStyle={style.underLayer}
                close={this.props.close}>
                    <AddForm gyms={this.props.gyms}/>
            </ModalOverlay>
        );
    }
}

const style = {
    modalStyle: {
        backgroundColor: theme.color.white,
        borderRadius: 3,
        paddingLeft: "20px",
        paddingRight: "20px"
    },
    headerStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        backgroundColor: theme.color.transparent
    },
    headerBodyStyle: {
        width: "100%",
        height: 40,
        fontSize: 25,
        letterSpacing: 0,
        borderRadius: 3,
        lineHeight: "40px",
        fontFamily: theme.font.avenirBlackOblique,
        color: theme.color.thickGrey,
    },
    modalBody: {
        maxWidth: "800px",
        margin: 25,
        marginTop: 0,
        borderRadius: "0px 0px 15px 15px",
        backgroundColor: theme.color.transparent
    },
    underLayer: {
        backgroundColor: theme.color.shadowColor
    }
}